import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import {
  DocumentPreview,
  MiContentDrawer,
  MiDrawerHeader,
} from "@miplatform/components";
import {
  APP_BAR_HEIGHT,
  APP_BAR_HEIGHT_TABLET,
  MIBUILD_PAGE_HEADER_HEIGHT,
} from "@miplatform/constants";
import {
  ICreditMemoDetailsResponse,
  IInvoiceResponse,
} from "@miplatform/types";
import { mdiClose } from "@mdi/js";
import { Box } from "@mui/material";
import { useMediaQuery } from "@mui/system";

export const InvoiceViewerDrawer = memo(
  ({
    open = false,
    onClose = () => null,
    selectedDocument = null,
  }: {
    open: boolean;
    onClose: () => void;
    selectedDocument?: IInvoiceResponse | ICreditMemoDetailsResponse | null;
  }) => {
    const { classes, theme } = useStyles();

    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const DRAWER_TOP_OFFSET =
      (isTablet ? APP_BAR_HEIGHT_TABLET : APP_BAR_HEIGHT) +
      MIBUILD_PAGE_HEADER_HEIGHT;

    const header = (
      <MiDrawerHeader
        title="Document Details"
        subtitle={[selectedDocument?.home?.address?.addressLine1 || "Address"]}
        rightIcon={mdiClose}
        rightIconColor={theme.palette.common.black}
        onRightIconClick={onClose}
      />
    );

    return (
      <MiContentDrawer
        variant="persistent"
        open={open}
        onClose={onClose}
        hideBackdrop
        sx={{
          "& > .MuiPaper-root": {
            top: DRAWER_TOP_OFFSET,
            height: `calc(100% - ${DRAWER_TOP_OFFSET}px)`,
            borderLeft: `${theme.spacing(1)} solid ${theme.palette.grey[300]}`,
          },
        }}
      >
        <Box className={classes.viewContainer} height="inherit">
          {header}
          <Box className={classes.content}>
            <DocumentPreview selectedDocument={selectedDocument?.document} />
          </Box>
        </Box>
      </MiContentDrawer>
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  viewContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
  },
  content: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    overflow: "auto",
    height: "100%",
  },
}));
